import { SettingOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { Dashboard } from "../../../../components/ExportImgFigma";
import "../../styles.scss";
import MegaTable from "../../../../components/MagaTableV2";
import { mixGetV2 } from '../../../../services/mixin'

const ContactHistory = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const newData = () => {
    return stData.xequantam_show && stData.xequantam ? stData.xequantam.filter((item: any) => item.vehicle_name === stData.xequantam_show.vehicle_name) : []
  }
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_interest_history?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheContactHistory',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: "interaction_date", headerName: "Ngày tiếp xúc" },
      // { field: "vehicle_status", headerName: "Trạng thái KH" },
      // { field: "group_status_name", headerName: "Nhận định KH" },
      // { field: "branch_name", headerName: "Đơn vị " },
      // { field: "route_name", headerName: "Xưởng dịch vụ" },
      // { field: "customer_interactions_employee_name", headerName: "Nhân viên" },
      // { field: "customer_interactions_employee_code", headerName: "Mã nhân viên" },
      // { field: "details", headerName: "Nội dung tiếp xúc" },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });

  const [loading, setLoading] = useState(false);
  const getDetail = async (id: any) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/customers_interest_vehicle_history?id_sync=${stData.cus_id}&dms_doc_id=${id}`);
    if (res.data) {
      stChange({
        list: res.data.interactions,
        latest_interaction_date: res.data.latest_interaction_date,
        total_interactions: res.data.total_interactions
      }, 'customers_interest_vehicle_history');
      setLoading(false);
    }
  }
  useEffect(() => {
    if (stData.xequantam_show && stData.xequantam_show.dms_doc_id) {
      getDetail(stData.xequantam_show.dms_doc_id);
    }
  }, [stData.xequantam_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex gap-3 mb-3">
        <div className="custom-page-css  flex flex-1 flex-column rounded border mw-33">
          <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
            <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full w-1/3">
              <img
                src={Dashboard}
                alt=""
                style={{ height: 16, width: 16, objectFit: "contain" }}
              />
            </div>
            <span className="custom-page-css text-xl font-light text-475467">
              Tổng quan
            </span>
          </div>
          <div className="custom-page-css flex py-2">
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {newData().length}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Số lần tiếp xúc
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {newData().length > 0 ? newData()[0]?.interaction_date : "Không xác định"}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Ngày tiếp xúc gần nhất
              </span>
            </div>
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: newData() }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};
export default ContactHistory;
